export default __webpack_public_path__ + "static/media/03-ISA_1.06afafb3.gif";